import { ApproversInfo } from "@preveil-api";

export type ApproversInfoResponse = {
  optional_users?: ApproversInfo[];
  required_users?: ApproversInfo[];
  optionals_required?: number;
};

// Description: Validate returned approval group approvers response (crypto and collection server)
export function isValidApproversInfoResponse(params: ApproversInfoResponse): boolean {
  // Every approver is optional
  return (!!params.optional_users || !!params.required_users) &&
    (!!params.optionals_required && !isNaN(params.optionals_required) && params.optionals_required > 0);
}
